import React, { useEffect, useRef, useState, useImperativeHandle, forwardRef, } from "react";
import { Link, useParams } from "react-router-dom";
import DOMPurify from 'dompurify';
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import "../Customer-View/SendContract.css";
import TranslateWidget from "../Shared/TranslateWidget/TranslateWidget";
//import SideCanvas from "./SideCanvas";
import TextEditorToSection from "./TextEditorToSection";
import axios from "axios";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import { setTitle } from "../../redux/titleSlice";
//import SendToCustomerInfoModal from "./SendToCustomerInfoModal";
import { useNavigate } from "react-router-dom/dist/umd/react-router-dom.development";

import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import html2pdf from 'html2pdf.js';
import { FaUnderline } from "react-icons/fa";




// Strip default placeholder content that appears when a new page is added
const stripPlaceholder = (html) => {
  if (!html) return html;
  return html
    .replace(/<p[^>]*>\s*Your new page content goes here\.\s*<\/p>/gi, '')
    .replace(/<h1[^>]*>\s*Page\s+\d+\s*<\/h1>/gi, '');
};

const SendContract = forwardRef((props, ref) => {
  // Reference for the SunEditor instance
  const { eventID, contractid, code } = useParams();
  const editorRefs = useRef([]);
  let [contractCount, setContractCount] = useState(0);
  const [length, setlength] = useState(0);
  const title = useSelector((state) => state.title.title);
  const [contracttitle, setContracttitle] = useState("1");
  const [tabs, setTabs] = useState([]);

  const [currentPage, setCurrentPage] = useState(0);

  //const { contractId } = useParams();
  const navigate = useNavigate();
  const [contract, setContract] = useState(null);
  const dispatch = useDispatch();

  const [username, setusername] = useState('');
  const [useremail, setuseremail] = useState('');
  const [customername, setcustomername] = useState('');
  const [customeremail, setcustomeremail] = useState('');

  const [customersignature, setcustomersignature] = useState('');
  const [signaturebox, setsignaturebox] = useState("");

  const [isChecked, setIsChecked] = useState(false);

  const [showsign, setshowsign] = useState(false);

  const [showpaging, setshowpaging] = useState(false);

  const [alreadysigned, setalreadysigned] = useState(false);

  const [usersignature, setUsersignature] = useState('');

  const [shareduserdetail, setshareduserdetail] = useState([]);

  const [pdfUrl, setPdfUrl] = useState(null);




  const handleChange = (event) => {
    setsignaturebox(event.target.value);
  };
  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };


  const addsignature = async () => {

    // setcustomersignature(signaturebox);

    const options = {
      margin: [0.75, 0.75, 0.75, 0.75],
      filename: 'contract.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true, letterRendering: true },
      jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' },
      pagebreak: { mode: ['css', 'legacy'], before: '.pdf-page-break' },
    };

    const styles = `
  <style>
    @import url('https://fonts.googleapis.com/css2?family=Allura&display=swap');
    .pdf-body {
      font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
      font-size: 13px;
      line-height: 1.7;
      color: #222;
      word-wrap: break-word;
      overflow-wrap: break-word;
    }
    .pdf-body p { margin: 0 0 10px 0; }
    .pdf-body h1 { font-size: 22px; margin-top: 0; margin-bottom: 10px; }
    .pdf-body h2 { font-size: 18px; margin-top: 18px; margin-bottom: 8px; }
    .pdf-body h3, .pdf-body h4, .pdf-body h5 {
      margin-top: 14px; margin-bottom: 6px;
    }
    .pdf-body img { max-width: 100%; height: auto; }
    .pdf-body table { border-collapse: collapse; width: 100%; margin-bottom: 12px; }
    .pdf-body td, .pdf-body th { padding: 6px 8px; }
    .pdf-page-content { padding: 0; }
    .pdf-signature-section {
      margin-top: 50px;
      padding-top: 20px;
      page-break-inside: avoid;
    }
    .pdf-sig-block { display: inline-block; width: 45%; vertical-align: top; }
    .pdf-sig-name {
      font-family: 'Allura', cursive;
      font-size: 36px;
      font-weight: 400;
      line-height: 1.2;
      min-height: 50px;
      border-bottom: 1px solid #999;
      padding-bottom: 4px;
      margin-bottom: 6px;
    }
    .pdf-sig-details {
      font-size: 11px;
      color: #555;
      line-height: 1.5;
    }
    .pdf-page-break { page-break-before: always; }
  </style>
`;
    const pdfContent = document.createElement('div');
    pdfContent.style.width = '6.77in';
    pdfContent.className = 'pdf-body';

    pdfContent.innerHTML = styles;

    // Iterate over each tab and create a section for the PDF
    tabs.forEach((tab, index) => {
      // Add a page break before each tab except the first one
      if (index > 0) {
        const pageBreak = document.createElement('div');
        pageBreak.className = 'pdf-page-break';
        pdfContent.appendChild(pageBreak);
      }

      const tabContent = document.createElement('div');
      tabContent.className = 'pdf-page-content';
      tabContent.innerHTML = stripPlaceholder(tab.content);

      // Check if it's the last tab to include the signature
      if (index === tabs.length - 1) {
        tabContent.innerHTML += `
        <div class="pdf-signature-section">
          <div class="pdf-sig-block">
            <div class="pdf-sig-name">${usersignature || ''}</div>
            <div class="pdf-sig-details">
              <div>${username}</div>
              <div>${useremail}</div>
            </div>
          </div>
          <div style="display:inline-block;width:9%;"></div>
          <div class="pdf-sig-block">
            <div class="pdf-sig-name">${signaturebox}</div>
            <div class="pdf-sig-details">
              <div>${customername}</div>
              <div>${customeremail}</div>
            </div>
          </div>
        </div>
    `;
      }

      pdfContent.appendChild(tabContent);
    });

    // To send the PDF to your backend, use the following approach
    const pdfBlob = await html2pdf().from(pdfContent).set(options).toPdf().get('pdf').output('blob');
    const formData = new FormData();
    formData.append('file', pdfBlob, 'contract.pdf');

    formData.append('sharedid', contractid);
    formData.append('signature', signaturebox);

    try {
      /* const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/setcustomersign', 
                     {sharedid: contractid,
                     });  */

      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/setcustomersign`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.data.success) {
        // alert('Email send Sucessfully');
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Action complete Sucessfully!",
        });
        // navigate("/events");
      }

      setcustomersignature(signaturebox);
    } catch (error) {
      console.error("Error fetching contracts:", error);
    }



  };

  const handleNextPage = () => {

    if (currentPage == length && customersignature == '') {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Your signature is required before proceeding.Please sign the contract and then click the Next button",
      });
      return false;
    }

    if (currentPage < length + 2) {
      setCurrentPage(currentPage + 1);

    } else {

    }

    if (currentPage == length - 1) {
      setshowsign(true);
    } else {
      setshowsign(false);
    }




  };

  // Handler for the previous button
  const handlePreviousPage = () => {



    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
    const nowpage = currentPage;
    // alert(length+'--'+currentPage);
    if (length + 1 === nowpage && currentPage > 0) {

      setshowsign(true);

    } else {

      setshowsign(false);
    }


  };




  const showPopup = () => {
    alert("Popup triggered!");
  };

  const textareaRef = useRef(null);

  // Function to adjust the height of the textarea
  const adjustHeight = () => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = 'auto'; // Reset height to auto to calculate the new height
      textarea.style.height = `${textarea.scrollHeight}px`; // Set the height based on scrollHeight
    }
  };

  useEffect(() => {
    adjustHeight(); // Adjust height on initial render
  }, [tabs, currentPage]); // Adjust height when content changes







  //let c = contractCount;
  var count = 0;
  useEffect(() => {
    const fetchContract = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/sharedcontracts/${contractid}/${code}`);
        const userIdFromInvoice = response?.data?.sharedcontract?.user_id;
        if (userIdFromInvoice) {
          localStorage.setItem('shared_user_id', userIdFromInvoice);
        }
        if (response.data.sharedcontract.signed != 'yes') {

          setshareduserdetail(response.data.user);
          setContract(response.data.sharedcontract);
          count = 10;
          setContracttitle(response.data.sharedcontract.title);
          const length = JSON.parse(response.data.sharedcontract.pages).length;
          setlength(length - 1);
          setTabs(JSON.parse(response.data.sharedcontract.pages));
          setusername(response.data.sharedcontract.username);
          setuseremail(response.data.sharedcontract.user_email);
          setcustomername(response.data.sharedcontract.customer_name);
          setcustomeremail(response.data.sharedcontract.customer_email);
          setUsersignature(response.data.sharedcontract.usersignature || '');

          if(response.data.sharedcontract.signed!==null){

             setalreadysigned(true);

          }

          //alert(length);
      if (length == 1) {
            setshowsign(true);
            // setshowpaging(true)
          }

        } else {
         

        }

      } catch (error) {
        console.error('Error fetching contract:', error);
      }
    };
    fetchContract();
  }, []);


  const generatepdf2 = async () => {
    const options = {
      margin: [0.75, 0.75, 0.75, 0.75],
      filename: 'contract.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true, letterRendering: true },
      jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' },
      pagebreak: { mode: ['css', 'legacy'], before: '.pdf-page-break' },
    };

    const styles = `
  <style>
    @import url('https://fonts.googleapis.com/css2?family=Allura&display=swap');
    .pdf-body {
      font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
      font-size: 13px;
      line-height: 1.7;
      color: #222;
      word-wrap: break-word;
      overflow-wrap: break-word;
    }
    .pdf-body p { margin: 0 0 10px 0; }
    .pdf-body h1 { font-size: 22px; margin-top: 0; margin-bottom: 10px; }
    .pdf-body h2 { font-size: 18px; margin-top: 18px; margin-bottom: 8px; }
    .pdf-body h3, .pdf-body h4, .pdf-body h5 {
      margin-top: 14px; margin-bottom: 6px;
    }
    .pdf-body img { max-width: 100%; height: auto; }
    .pdf-body table { border-collapse: collapse; width: 100%; margin-bottom: 12px; }
    .pdf-body td, .pdf-body th { padding: 6px 8px; }
    .pdf-page-content { padding: 0; }
    .pdf-signature-section {
      margin-top: 50px;
      padding-top: 20px;
      page-break-inside: avoid;
    }
    .pdf-sig-block { display: inline-block; width: 45%; vertical-align: top; }
    .pdf-sig-name {
      font-family: 'Allura', cursive;
      font-size: 36px;
      font-weight: 400;
      line-height: 1.2;
      min-height: 50px;
      border-bottom: 1px solid #999;
      padding-bottom: 4px;
      margin-bottom: 6px;
    }
    .pdf-sig-details {
      font-size: 11px;
      color: #555;
      line-height: 1.5;
    }
    .pdf-page-break { page-break-before: always; }
  </style>
`;
    const pdfContent = document.createElement('div');
    pdfContent.style.width = '6.77in';
    pdfContent.className = 'pdf-body';

    pdfContent.innerHTML = styles;

    // Iterate over each tab and create a section for the PDF
    tabs.forEach((tab, index) => {
      // Add a page break before each tab except the first one
      if (index > 0) {
        const pageBreak = document.createElement('div');
        pageBreak.className = 'pdf-page-break';
        pdfContent.appendChild(pageBreak);
      }

      const tabContent = document.createElement('div');
      tabContent.className = 'pdf-page-content';
      tabContent.innerHTML = stripPlaceholder(tab.content);

      // Check if it's the last tab to include the signature
      if (index === tabs.length - 1) {
        tabContent.innerHTML += `
        <div class="pdf-signature-section">
          <div class="pdf-sig-block">
            <div class="pdf-sig-name">${usersignature || ''}</div>
            <div class="pdf-sig-details">
              <div>${username}</div>
              <div>${useremail}</div>
            </div>
          </div>
          <div style="display:inline-block;width:9%;"></div>
          <div class="pdf-sig-block">
            <div class="pdf-sig-name">${customersignature}</div>
            <div class="pdf-sig-details">
              <div>${customername}</div>
              <div>${customeremail}</div>
            </div>
          </div>
        </div>
    `;
      }

      pdfContent.appendChild(tabContent);
    });

    // Create the PDF from the constructed content
    await html2pdf()
      .from(pdfContent)
      .set(options)
      .save(); // Saves the PDF locally


  }



  const generatePDF = async () => {
    const doc = new jsPDF('p', 'mm', 'a4');

    const addPageToPdf = async (htmlContent, doc, pageNumber) => {
      const cleanedContent = htmlContent || `<div>
            <h1>Contract</h1>
            <p class="mt-5">Please type or copy and paste the content of your contract here.</p>
            <p class="mt-5">If you don’t have a contract, you can browse our template gallery.</p>
            <p class="mt-5">And remember to delete this text before sending.</p>
            <p class="smart_text">smart_text</p>
        </div>`;

      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = cleanedContent;
      tempDiv.style.width = '210mm'; // Set width to A4 size
      tempDiv.style.position = 'absolute';
      tempDiv.style.left = '0px';
      tempDiv.style.top = '0px';
      tempDiv.style.opacity = '0'; // Fully transparent

      document.body.appendChild(tempDiv); // Append to body for rendering

      // Allow the browser to render the tempDiv
      await new Promise(resolve => setTimeout(resolve, 500)); // Increased timeout

      const canvas = await html2canvas(tempDiv, {
        scale: 2,
        backgroundColor: null, // Adjust as needed
      });

      const imgData = canvas.toDataURL('image/png');

      if (!imgData) {
        console.error("Failed to generate image data from canvas.");
        document.body.removeChild(tempDiv); // Remove after rendering
        return;
      }

      const imgProps = doc.getImageProperties(imgData);
      const pdfWidth = doc.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

      if (pageNumber > 0) {
        doc.addPage();
      }

      doc.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
      document.body.removeChild(tempDiv); // Remove after rendering
    };

    // For debugging, use static content for each page
    for (let index = 0; index < tabs.length; index++) {
      await addPageToPdf('<div><h1>Test PDF Content</h1></div>', doc, index);
    }

    const pdfBlob = doc.output('blob');
    const pdfUrl = URL.createObjectURL(pdfBlob);
    setPdfUrl(pdfUrl); // Set the URL for the generated PDF
  };

  // Set a timeout to call the generatePDF function after 1 second


  // 1-second delay to wait for all content to load


  // setContractCount(count);
  if (!contract && !alreadysigned) {
    return <div>Loading...</div>;
  }


  if (alreadysigned) {
    return <div>You have already signed this contract</div>;
  }






  return (
    <>
      <div className="customer-view-translate-bar bg-light border-bottom">
        <div className="customer-view-translate-bar-inner">
          <TranslateWidget />
        </div>
      </div>
      <div
        className="container-fluid d-flex align-items-center justify-content-center"
        style={
          currentPage === length + 1
            ? {
              backgroundColor: '#e8eff7',
              
              textAlign: 'center',
              flexDirection: 'column',
            }
            : {
              minHeight: '100vh',
              textAlign: 'center',
              flexDirection: 'column',
            }
        }
      >

        <div style={{ textAlign: 'center', margin: '0 auto', display: 'contents' }}
        >

          {/* Text Editor part */}
          <div className='widthfix-container'>
            {/* mobcon */}
            <div className="gap"> &nbsp; {/* <button onClick={generatepdf2}>Generate PDF and Send</button> */} </div>
            <div className="gap"> &nbsp; </div>
            <div className='text-editor px-2 px-md-5 py-3 bg-view-contract'  >
              {!showpaging && (<>

                <div className="pagination-controls col-md-12 text-end">
                  {currentPage > 0 ? (<>
                    <button onClick={handlePreviousPage} disabled={currentPage === 0} className="Nxt">
                      Previous
                    </button>
                  </>) : (<></>)}

                  <span> Page {currentPage + 1} of {length + 2} </span>

                  {currentPage < length + 1 ? (<>
                    <button onClick={handleNextPage} disabled={currentPage === length + 1} className="Nxt">
                      Next
                    </button>
                  </>) : (<></>)}


                </div>
              </>)}


            </div>
            <div className='text-editor px-2 px-md-5 py-5 hightauto ' style={currentPage == length + 1 ? {
              backgroundColor: '#ffffff', border: '1px solid rgb(208, 200, 200)',  boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)', borderRadius: '20px',
              margin: '0 auto'
            } : { border: '1px solid rgb(208, 200, 200)',  backgroundColor: '#ffffff', boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)', borderRadius: '20px', margin: '0 auto' }}>
              <div></div>
              {currentPage <= length && (<>

                {currentPage == '0' && (<>
                  <TextEditorToSection userDetail={shareduserdetail} />
                </>)}

                <div className="row left">
                  <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(stripPlaceholder(tabs[currentPage].content)) }} />


                </div>

              </>)}

              {usersignature != '' && currentPage == length + 1 && (<>

                <div style={{ width: '75%', margin: '0px auto' }}>

                  <div className='logo' style={{ width: '50%', margin: '0px auto' }}>
                    <img src={shareduserdetail.Secondary_Logo ? process.env.REACT_APP_BACKEND_URL + shareduserdetail.Secondary_Logo : null} alt='Secondary Logo Preview' className='mainimgpath ' style={{ maxWidth: '200px' }} />
                  </div>

                  <div style={{ fontSize: '26px' }}><b>All done!</b></div>

                  <div style={{ textAlign: "centre", margin: '10px' }}>Your contract has been successfully signed. You can download it from the link below, and a copy will also be sent to your email. {usersignature && (<>Please note: The contract is not fully executed until it has been signed by both parties.</>)} </div>
                  <div> <span onClick={generatepdf2} style={{ textDecoration: 'underline', cursor: 'pointer' }}>Click Here to Download Contract</span> </div>
                </div>

              </>)}

              {/* text editor page */}

              {showsign && (<>

                <div className={"tab-pane"} id='sign' role="tabpanel" aria-labelledby={`sign-tab`} style={{ background: 'white', height: '100%' }} >

                  <div className="position-relative overflow-hidden">

                    <div className="signat">

                      <div className="gap"> &nbsp; </div>
                      <div className="gap"> &nbsp; </div>
                      <div className="gap"> &nbsp; </div>




                      {usersignature !== null && (<>
                        <div className="signaturemain left w-100">
                          {usersignature}
                        </div>
                      </>)}



                      <div className="sign_text">{username}  </div>
                      <div className="sign_text">{useremail}</div>

                      <div className="gap"> <hr /> </div>

                      {customersignature == "" && (<>
                        <div className="addbutton">
                          <button

                            className={`nav-link add_Signature`}
                            type='button'
                            data-bs-toggle='offcanvas'
                            data-bs-target='#signpopup'
                            aria-controls='offcanvasRight'
                          >Add Signature </button>

                        </div>
                      </>)}

                      {customersignature != "" && (<>
                        <div className="signaturemain left w-100">
                          {customersignature}
                        </div>
                      </>)}

                      <div className="sign_text">{customername} </div>
                      <div className="sign_text">{customeremail}</div>


                    </div>

                  </div>

                </div>
              </>)}

              {/* add page */}

            </div>


            <div className='text-editor px-2 px-md-5 py-3 bg-view-contract'>

              {!showpaging && (<>

                <div className="pagination-controls col-md-12 text-end">
                  {currentPage > 0 ? (<>
                    <button onClick={handlePreviousPage} disabled={currentPage === 0} className="Nxt">
                      Previous
                    </button>
                  </>) : (<></>)}

                  <span> Page {currentPage + 1} of {length + 2} </span>

                  {currentPage < length + 1 ? (<>
                    <button onClick={handleNextPage} disabled={currentPage === length + 1} className="Nxt">
                      Next
                    </button>
                  </>) : (<></>)}


                </div>

              </>)}
            </div>

          </div>

          {/* Contract Right Area */}

        </div>

      </div>

      {/* start of the sign popup */}
      <div
        class='offcanvas offcanvas-end'
        tabindex='-1'
        id='signpopup'
        aria-labelledby='offcanvasRightLabel'
        data-bs-backdrop='false'>
        <div class='w-100 text-start header'>
          <button
            type='button'
            class='btn-close mt-3 ms-4 text-black'
            data-bs-dismiss='offcanvas'
            aria-label='Close'></button>


          <div className='text-center py-3'>
            <h5>Signature</h5>
            <span style={{ color: "#727272" }}>
              Add Your Signature
            </span>
          </div>
        </div>


        <div class='offcanvas-body p-0'>

          <div className='single_box mt-3'>
            <div className='d-flex align-items-center justify-content-between'>
              <div >
                <input type="text" className="signbox" onChange={handleChange} value={signaturebox} />
              </div>
            </div>
          </div>

          <div className='single_box mt-3'>
            <div className='d-flex align-items-center justify-content-between'>
              <div >
                <input type="checkbox" onChange={handleCheckboxChange} />By Clicking, I, <b> {customername}  </b> hereby consent to the use of my electronic signature for the execution of this document. I acknowledge and agree that my electronic signature shall have the same validity, enforceability, and legal effect as my handwritten signature.
              </div>
            </div>
          </div>

          <div className='single_box mt-3'>
            <div className='d-flex align-items-center justify-content-between'>
              <div >
                <button
                  type='button'
                  class='mt-3 ms-4 text-black backbackground add_Signature'
                  data-bs-dismiss='offcanvas'
                  disabled={!isChecked}
                  onClick={addsignature}
                  aria-label='Close'>SIGN</button>
              </div>
            </div>
          </div>

        </div>







      </div>



      {/* end of the sign popup */}



    </>
  );
});
export default SendContract;